import { useState, useEffect } from 'react';
import type React from 'react';
import type {
  Control,
  FieldErrors,
  FieldValues,
  UseFormHandleSubmit,
  SubmitHandler,
} from 'react-hook-form';

import Heading from 'components/partials/heading/heading';
import Button from 'components/partials/button/button';

import BasicInfoForm from 'containers/admin/clients/client/forms/basic-info-form/basic-info-form';
import AsignedConsultantsForm from 'containers/admin/clients/client/forms/asigned-consultants-form/asigned-consultants-form';

interface ClientFormProps {
  isFormDisabled?: boolean;
  isSaving?: boolean;
  onCancel: () => void;
  control: Control<FieldValues>;
  onSubmit: SubmitHandler<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  errors: FieldErrors;
  clearErrors: (name?: string) => void;
}

const ClientForm = ({
  isFormDisabled,
  isSaving,
  onCancel,
  control,
  onSubmit,
  handleSubmit,
  errors,
  clearErrors,
}: ClientFormProps): React.JSX.Element => {
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(false);

  useEffect(() => {
    setIsSaveBtnDisabled(Object.keys(errors).length !== 0);
  }, [Object.keys(errors).length]);

  return (
    <div className="flex flex-col" data-testid="client-form-container">
      <div className="flex w-full">
        <Heading variant="h3" customClass="w-3/6 mr-16">
          Basic information
        </Heading>
        <Heading variant="h3" customClass="w-3/6">
          Assigned consultants
        </Heading>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col w-full"
        data-testid="client-form"
      >
        <div className="flex">
          <BasicInfoForm
            {...{ isFormDisabled, control, errors, clearErrors }}
          />
          <AsignedConsultantsForm {...{ isFormDisabled, control }} />
        </div>
        {!isFormDisabled && (
          <div className="flex justify-end">
            <Button
              type="button"
              variant="reserve-text"
              size="md"
              onClick={onCancel}
              data-testid="client-form-cancel-button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isSaveBtnDisabled || isSaving}
              variant="brand-filled"
              size="md"
              data-testid="client-form-save-button"
            >
              Save client
            </Button>
          </div>
        )}
      </form>
    </div>
  );
};

export default ClientForm;
